import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const toastComponent = (message: string, type: "info" | "success" | "warning" | "error" | "default" = "default") => {
  const toastOptions: any = {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  // Apply custom styles based on type
  switch (type) {
    case "success":
      toastOptions.style = {
        background: "rgb(22, 163, 74)", // Green
        color: "white",
      };
      break;
    case "error":
      toastOptions.style = {
        background: "rgb(220, 38, 38)", // Red
        color: "white",
      };
      break;
    case "warning":
      toastOptions.style = {
        background: "rgb(245, 158, 11)", // Orange/Amber
        color: "white",
      };
      break;
    case "info":
      toastOptions.style = {
        background: "rgb(59, 130, 246)", // Blue
        color: "white",
      };
      break;
    default:
      toastOptions.theme = "dark";
      break;
  }

  return toast(<p className="toastMessage">{message}</p>, toastOptions);
};
